export default __webpack_public_path__ + "static/media/check.f25b142e.svg";